<script setup>
/**
 * FormHistoryOffcanvas
 * Provides a slide-out panel for viewing record history.
 * Listens to Bootstrap offcanvas events to toggle the 'open' state,
 * which controls the lazy-loading of the ItemHistory child component.
 */
import { ref, onMounted, getCurrentInstance } from 'vue';
import ItemHistory from "../item-history/ItemHistory.vue";

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
});

const { proxy } = getCurrentInstance();

// --- State ---

const open = ref(false);

// --- Lifecycle ---

onMounted(() => {
    const el = document.getElementById('historyOffcanvas');
    if (el) {
        el.addEventListener('show.bs.offcanvas', () => {
            open.value = true;
        });
        el.addEventListener('hide.bs.offcanvas', () => {
            open.value = false;
        });
    }
});
</script>

<template>
    <div
        id="historyOffcanvas"
        class="offcanvas offcanvas-end w-50"
        tabindex="-1"
        aria-labelledby="historyOffcanvasLabel"
    >
        <div class="offcanvas-header">
            <h5 id="historyOffcanvasLabel" class="offcanvas-title">History</h5>
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            />
        </div>

        <div class="offcanvas-body">
            <ItemHistory v-if="open" :form-id="formId"/>
        </div>
    </div>
</template>